import { all, put, call, fork, take } from "redux-saga/effects";
import * as api from "../../utils/api";
import { quizActions, GET_QUIZ_REQUEST, ANSWER_QUIZ_REQUEST } from "./actions";

export function* asyncGetQuiz({ payload, resolve, reject }) {
  try {
    const quizRes = yield call(api.getQuiz);
    if (quizRes.status === 200 && quizRes.data) {
      yield put(quizActions.getQuizSuccess(quizRes.data));
    }
    resolve(quizRes.data);
  } catch (err) {
    reject(err);
  }
}
export function* asyncAnswerQuiz({ payload, resolve, reject }) {
  try {
    const updateRes = yield call(api.answerQuiz, payload);
    if (updateRes.status === 201) {
      //yield put(quizActions.answerQuizSuccess({answer: updateRes.data, question: payload}));
      resolve(updateRes.data);
    } else {
    }
  } catch (err) {
    reject(err);
  }
}

export function* watchAnswerQuiz() {
  while (true) {
    const action = yield take(GET_QUIZ_REQUEST);
    yield* asyncGetQuiz(action);
  }
}
export function* watchGetQuiz() {
  while (true) {
    const action = yield take(ANSWER_QUIZ_REQUEST);
    yield* asyncAnswerQuiz(action);
  }
}

export default function* () {
  yield all([fork(watchGetQuiz), fork(watchAnswerQuiz)]);
}
